import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { useAttrs, onMounted, nextTick, onUpdated, onUnmounted, computed, onBeforeMount } from 'vue';
import { pick } from 'lodash-es';
import { Form, Row } from 'ant-design-vue';
import SchemaFormItem from './schema-form-item.vue';
import FormAction from './components/form-action.vue';
import { watch } from "vue"
import { GuidID } from "../../lt-a-table/src/hooks/commonMethods"
import { setLabelStyle, createValidateToolTip, clearValidateToolTip, removeAllTooltips } from "./hooks/commonFormMethods"
import {
  createFormContext,
  useFormState,
  useFormEvents,
  useFormMethods,
  useAdvanced,
  type SchemaFormType,
} from './hooks';
import { schemaFormProps, schemaFormEmits, aFormPropKeys } from './schema-form';


export default /*@__PURE__*/_defineComponent({
  __name: 'schema-form',
  props: schemaFormProps,
  emits: schemaFormEmits,
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;


const emit = __emit;

const attrs = useAttrs();
const formID = "form-" + GuidID()
const showProps = computed(() => {
  const temp = pick(getFormProps, aFormPropKeys)
  console.log("form的props内容：" + JSON.stringify(temp))
  return pick(getFormProps, aFormPropKeys)
})

// 表单内部状态
const formState = useFormState({ props, attrs });

const {
  formModel,
  getRowConfig,
  schemaFormRef,
  getFormProps,
  getFormActionBindProps,
  formSchemasRef,
} = formState;

// 表单内部方法
const formMethods = useFormMethods({ ...formState });
const { initFormValues, handleFormValues, setSchemaFormProps } = formMethods;

// 初始化表单默认值
initFormValues();

// a-form表单事件二次封装和扩展
const formEvents = useFormEvents({ ...formState, emit, handleFormValues });

// 同步外部对props的修改
watch(props, () => {
  setSchemaFormProps(props)
}, {
  deep: true,
  immediate: true,
});


watch(() => props.initialValues, () => {
  setSchemaFormProps(props)
  // console.log("执行重新赋值函数")
}, {
  deep: true,
  immediate: true,
});


watch(() => formModel, (val) => {
  emit("updateData", val)
}, {
  deep: true
})

// 当前组件所有的状态和方法
const instance = {
  ...formState,
  ...formEvents,
  ...formMethods,
} as SchemaFormType;

// 搜索表单 展开/收起 表单项hooks
const { handleToggleAdvanced } = useAdvanced({
  instance,
  emit,
});

const handleValiddate = function (name, status, errorMsgs) {
  emit("validate", name, status, errorMsgs) //无论验证的信息是否正确，都将原始验证信息推送出去
  nextTick(() => {
    //如果校验不通过，则需要对界面生成的校验信息进行处理
    if (!status) {
      let targetTable = $("#" + formID)
      if (name.length > 0) {
        let targetInput = targetTable.find("#" + "form_item_" + name[0])
        if (targetInput.length) {
          //生成自定义提示信息
          createValidateToolTip(targetInput, errorMsgs)
        }
      }

    }
  })
}

emit('register', instance);
createFormContext(instance);

__expose(instance);

onBeforeMount(() => {
  removeAllTooltips()
})

onMounted(() => {
  if (props.isOutline == true) {
    setLabelStyle(formSchemasRef, formID, formModel)
  }
})
onUpdated(() => {
  //数据变化的时候，主动调用验证规则
  schemaFormRef.value?.validate()
  clearValidateToolTip(formID)
})
onUnmounted(() => {
  //销毁的时候，要去掉生成的tooltips 并且去掉所有的监听事件
  clearValidateToolTip(formID)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), _mergeProps({
    ref_key: "schemaFormRef",
    ref: schemaFormRef
  }, showProps.value, {
    model: _unref(formModel),
    id: formID,
    onValidate: handleValiddate,
    class: props.isOutline == true ? 'ltaui-form' : '',
    autocomplete: "off"
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(Row), _normalizeProps(_guardReactiveProps(_unref(getRowConfig))), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "formHeader"),
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formSchemasRef), (schemaItem) => {
              return (_openBlock(), _createBlock(SchemaFormItem, {
                key: schemaItem.field,
                "form-model": _unref(formModel),
                "onUpdate:formModel": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formModel) ? (formModel).value = $event : null)),
                schema: schemaItem,
                "table-instance": _ctx.tableInstance,
                rules: _ctx.rules
              }, _createSlots({ _: 2 }, [
                _renderList(Object.keys(_ctx.$slots), (item) => {
                  return {
                    name: item,
                    fn: _withCtx((data) => [
                      _renderSlot(_ctx.$slots, item, _mergeProps({ ref_for: true }, data || {}))
                    ])
                  }
                })
              ]), 1032, ["form-model", "schema", "table-instance", "rules"]))
            }), 128)),
            (_ctx.showActionButtonGroup)
              ? (_openBlock(), _createBlock(FormAction, _mergeProps({ key: 0 }, _unref(getFormActionBindProps), { onToggleAdvanced: _unref(handleToggleAdvanced) }), _createSlots({ _: 2 }, [
                  _renderList(['resetBefore', 'submitBefore', 'advanceBefore', 'advanceAfter'], (item) => {
                    return {
                      name: item,
                      fn: _withCtx((data) => [
                        _renderSlot(_ctx.$slots, item, _normalizeProps(_guardReactiveProps(data || {})))
                      ])
                    }
                  })
                ]), 1040, ["onToggleAdvanced"]))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "formFooter")
        ]),
        _: 3
      }, 16)
    ]),
    _: 3
  }, 16, ["model", "class"]))
}
}

})